<template>
  <el-dialog
    :title="commodityChartTitle"
    :visible.sync="showCommodityChartDialog"
    :close-on-click-modal="false"
    custom-class="tipPop tipDialog commodityDialog"
    width="980px">
    <div class="pure-text">
      <div class="dialog-top-div">
        <el-tabs class="tabs" v-model="activeName"  @tab-click="commodityHandleClick">
          <el-tab-pane label="1w" name="first"></el-tab-pane>
          <el-tab-pane label="1mo" name="second"></el-tab-pane>
          <el-tab-pane label="1yr" name="third"></el-tab-pane>
          <el-tab-pane label="All" name="for"></el-tab-pane>
        </el-tabs>
        <span class="time-span">{{commodityLastDate}}</span>
      </div>

      <div style="height:400px;width:100%;margin-top:10px;background-color: #F3F3F3"  ref="dialogEchart"></div>
      <div class="echarts-tab charts-tab-dialog">
        <ul class="order-con">
          <li class="li-100">
            <span class="name" style="line-height: 30px">{{$t('financingFundDetail.date')}}：</span>
            <span class="con">{{commoditySelectedData.date}}</span>
          </li>
          <li>
            <span class="name">{{$t('financingFundDetail.open')}}：</span>
            <span class="con">{{commoditySelectedData.open}}</span>
          </li>
          <li>
            <span class="name">{{$t('financingFundDetail.high')}}：</span>
            <span class="con">{{commoditySelectedData.high}}</span>
          </li>
          <li>
            <span class="name">{{$t('financingFundDetail.low')}}：</span>
            <span class="con">{{commoditySelectedData.low}}</span>
          </li>
          <li>
            <span class="name">{{$t('financingFundDetail.settle')}}：</span>
            <span class="con">{{commoditySelectedData.settle}}</span>
          </li>
          <li>
            <span class="name">{{$t('financingFundDetail.volume')}}：</span>
            <span class="con">{{commoditySelectedData.volume}}</span>
          </li>
          <li class="li-100 foot">
            <span class="name" style="line-height: 30px;">{{$t('financingFundDetail.prevDayOpenInterest')}}：</span>
            <span class="con">{{commoditySelectedData.prevDayOpenInterest}}</span>
          </li>
        </ul>
        <!--                                                    <span class="foot">{{$t('ctTrade.prevDayOpenInterest')}} {{commoditySelectedData.prevDayOpenInterest}}</span>-->
      </div>
    </div>
    <div class="commodity-bottom-view">
      <el-button class="commodity-exportBtn" @click="exportCommodity">{{ $t("allorders.export") }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
let echarts = require("echarts/lib/echarts");
// 引入柱状图
require("echarts/lib/chart/line");
// // 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
export default {
  name: "commondityDialog",
  data(){
    return {
      commodityChartData:[],          //  商品数据折线数据
      showCommodityChart:false,       //  是否展示折线图
      showChartBack:true,             //  是否展示返回按钮
      commodityChartTitle:"",         //  选中的指数标题
      commodityLastDate:"",           //  最后刷新时间
      commodityChartCode:"",         //  选中的指数code
      commodityChartDate:"",         //  选中的指数日期
      showCommodityChartDialog:false, //  是否展示折线图弹框
      chart:null,                     //  商品折线图
      dialogChart:null,                     //  商品折线图
      activeName:'first',             //  商品数据默认选中tab
      commoditySelectedData:{},       //  商品数据默认选中对象

      wareCode:'', //商品
      exportUrl:'', //导出URL
    }
  },

  methods: {
    //商品code
    show(wareCode){
      this.wareCode = wareCode;
      this.activeName = 'first'
      this.showCommodityChartDialog = true;
      this.queryProductChartData(1)
    },

    commodityHandleClick(tab) {
      let type = parseInt(tab.index) + 1;
      this.queryProductChartData(type);
    },

    queryProductChartData(type){
      // 1：一周；2：一月；3：一年；4：所有
      let _this = this;
      let param = {
        w_type:type,
        w_code:_this.wareCode,
      };
      this.axios.post('/api/zma/loan/getWareData', param).then(res => {
        if (res.status) {
          // console.log(res.data);
          _this.exportUrl = res.data['downUrl']
          _this.queryProductChartDataSuccess(res.data);
        }else{
          _this.$message.error(_this.$t(`ctError.${res.errorCode}`));
        }
      })
    },

    caculateChartData2() {
      let _this = this;
      _this.dialogChart = echarts.init(_this.$refs.dialogEchart);
      let data = _this.commodityChartData;
      if (!data || data.length == 0){
        _this.dialogChart = null;
        return;
      }
      let options = {
        legend: {
          data: ['商品价格'],
        },
        grid: {
          left: '8%',
          right: '5%',
        }, //折线图居左、居右间距
        xAxis: {
          type: 'category',
          data: data.map(function (item) {
            return item.date;
          }),
          axisLine: {
            lineStyle: {
              color: '#C6C6C6'
            }
          },//图示折线属性
          axisLabel: {
            color: '#8D8D8D'
          }//横坐标title字体颜色
        },//横坐标属性
        yAxis: {
          type: 'value',
          axisLine: {
            show: true
          },//y轴线
          axisLabel: {
            color: '#8D8D8D'
          },
          axisTick: {
            show: true
          },//y轴线间距点
          splitLine: {
            lineStyle: {
              color: '#F2F3F4'
            }
          }
        },//纵坐标属性
        tooltip: {
          trigger: 'axis',
          formatter(item){
            // console.log(item,window.event);
            _this.echartsTabToMouse(item);

            let date = _this.commodityChartData[item[0].dataIndex].date;
            let settle = _this.commodityChartData[item[0].dataIndex].settle;
            // return  'date: ' + date  + 'settle: ' +settle;

            return _this.$t(`ctTrade.settle`) + ' : ' +settle + '<br>' + _this.$t(`ctTrade.date`) + ' : ' + date;
          },
          textStyle:{
            align:'left'
          }

        },
        series: {
          name:'价格',
          type: 'line',
          data: data.map(function (item) {
            return item.settle;
          }),
          // symbol:'none'
        }
      };
      _this.dialogChart.setOption(options);
      // _this.dialogChart.on('mouseover',function(params){
      //   // console.log('echarts自带的mouservoer',params);
      // });
      setTimeout(() => {
        _this.dialogChart.resize();
      }, 0)
      // setTimeout 处理echart 不能百分百显示bug
    },
    //处理折线图数据
    queryProductChartDataSuccess(data){
      let that = this;
      that.commodityLastDate = this.$t("ctTrade.lastUpdate") + data.lastDate;
      that.commodityChartData = data.oneCategory;
      if (that.commodityChartTitle.length==0){
        that.commodityChartTitle = data.oneCategory[0].name;
      }
      that.showCommodityChart = true;
      if(that.showCommodityChart){
        that.chart = null;
        setTimeout(() => {
          that.caculateChartData2();
        }, 0)
      }

    },
    //    echarts 鼠标跟随
    echartsTabToMouse(eItem) {
      const curMouseObj = window.event || window.ffEvent;
      // console.log(eItem[0].dataIndex);
      if(this.echartsTabIsShow){
        this.$refs.echartsTabMouse.style.top = `${curMouseObj.y - 140}px`;
        this.$refs.echartsTabMouse.style.left = `${curMouseObj.x - 30}px`;
      }
      this.commoditySelectedData =  this.commodityChartData[eItem[0].dataIndex];
    },

    //导出
    exportCommodity(){
      console.log('商品走势图导出')
      window.open(this.exportUrl)
    },
  },

}
</script>

<style lang="scss">
.commodityDialog{
  .el-dialog__header{
    background: #40404D;
    padding: 23px 35px 23px 35px;
    .el-dialog__title{
      font-size: 18px;
      color: #FFFFFF;
    }
    .el-dialog__headerbtn{
      font-weight: bold;
      right: 15px;
      //top: 15px;
      .el-dialog__close{
        color: #ffffff;
        font-size: 22px;
        font-weight: bold;
      }
    }
  }
  .echarts-tab{
    position: fixed;
    z-index: 10;
    width: 418px;
    background: #ffffff;
    //border: 1px solid #EAEAEA;
    box-shadow: 0 2px 6px 0 rgba(174,183,197,0.50);
    height: 140px;
    box-sizing: border-box;
    padding: 5px 6px;
    top:-200px;
    left: -418px;

    .order-con{
      display: flex;
      flex-wrap: wrap;

      li{
        width: 33%;
        box-sizing: border-box;
        display: flex;
        align-items: flex-start;
        line-height: 20px;

        .name{
          color: #333;
          font-size: 12px;
          background: #F5F7FA ;
          width: 54px;
          display: inline-flex;
          /*padding:5px 0px 5px 10px;*/
          padding-left: 10px;
          height: 100%;
          align-items: center;
          min-height: 30px;
        }
        .con{
          padding-left: 5px;
          padding-top: 5px;
          padding-bottom: 5px;
        }
      }
      li.li-100{
        width: 100%;
        .name{
          /*align-items: flex-start;*/
        }
      }
      .foot{
        margin-top: 5px;
        .name{
          width: 187px !important;
        }
        .con{
          /*padding-left: 10px !important;*/
        }
      }
    }

    /*.foot{*/
    /*    line-height: 20px;*/
    /*    margin: 5px 11px;*/
    /*    color: #333333;*/
    /*}*/
  }

  .charts-tab-dialog{
    display: block;
    position: relative;
    z-index: 0;
    width: 100%;
    height: 140px;
    border-bottom: 1px solid #EAEAEA;
    box-shadow: none;
    top:10px;
    left: 0px;
    text-align: left;
    font-size: 12px;

    .name{
      width: 84px !important;
    }
    .con{
      padding-left: 10px !important;
    }
    .foot{
      margin-top: 5px;
      .name{
        width: 383px !important;
      }
      .con{
        padding-left: 10px !important;
      }
    }
  }

  .commodity-bottom-view{
    height: 70px;
    .commodity-exportBtn{
      width: 150px;
      height: 38px;
      background: #7996f5;
      border-radius: 2px;
      color: #fff;
      float: right;
      margin-right: 30px;
      margin-top: 16px;
    }

  }

  .dialog-top-div{
    height: 50px;
    //margin-top: -10px;
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
    .tabs {

      .el-tabs__nav-scroll {
        padding: 0;
      }
      .div-container {
        padding: 20px 10px;
      }

      .el-tabs__item {

        padding: 0;
        font-size: 16px;
        height: 50px !important;
        line-height: 50px;
        width: 80px;
        text-align: center;
        &:last-child{
          padding: 0;
        }
      }
      .el-tabs__item {
        &.is-active {
          //background: red;
          border-bottom: 0;
          background: none;
          border: none;
        }
      }



      .el-tabs__nav-wrap::after {
        background-color: #EAEAEA;
        height: 1px;
      }

      .el-tabs__header {
        margin: 0;
      }

      .el-tabs__active-bar {
        //height: 100px;
      }
    }
    .time-span{
      float: right;
      width: 200px;
      height:30px;
      line-height: 30px;
      margin-top:10px;
      background-color: #F5F7FA;
      color: #BDC3D2;
    }
  }
}



</style>
